<template>
  <div class="list-container" style="font-family: Montserrat;font-weight: 500; font-size: 14px;">
    <div class="s-checkout-widget pt-2">
      <div id="s-checkout-id-1" class="s-checkout-one-step">
        <div class="ba-flex ba-pd-1 ba-gp-1 ba-jc-center ba-f-nowrap" style="justify-content: center;">
          <div style="display: flex; gap: 1rem; align-items: stretch;">
            <div class="invoice-contact-info">
              <div class="layout-one-step">
                <div>
                  <div class="ba-card" style="flex:1;">
                    <div class="ba-top"><span class="ba-title">{{ $t('ct-checkout-contact-information') }}</span></div>
                    <div class=" ba-flex ba-gp-1 ba-jc-sb ba-f-wrap">

                      <div class="ba-box-input w-full">
                        <div class="ba-info">
                          <div class="ba-info-left">
                              <label class="ba-label" style="font-family: Montserrat; font-weight: 500; font-size: 14px;" >
                                {{ $t('ct-checkout-input') }}
                                <span style="color: red;">*</span>
                              </label>
                            </div>
                        </div> 
                        <input :placeholder="$t('ct-checkout-empty-input')" type="text" class="ba-input ba-w-100" readonly="readyonly" :value="$t('ct-checkout-filled-input')">
                      </div>

                      <div class="ba-box-input w-full">
                        <div class="ba-info">
                          <div class="ba-info-left">
                              <label class="ba-label" style="font-family: Montserrat; font-weight: 500; font-size: 14px;">
                                {{ $t('ct-checkout-input') }}
                              </label>
                            </div>
                        </div> 
                        <input :placeholder="$t('ct-checkout-empty-input')" type="text" class="ba-input ba-w-100" readonly="readyonly">
                      </div>

                      <div class="ba-box-input w-full">
                        <div class="ba-info">
                          <div class="ba-info-left">
                              <label class="ba-label" style="font-family: Montserrat; font-weight: 500; font-size: 14px;">
                                {{ $t('ct-checkout-input') }}
                              </label>
                            </div>
                        </div> 
                        <input :placeholder="$t('ct-checkout-empty-input')" type="text" class="ba-input ba-w-100" readonly="readyonly">
                      </div>

                    </div>
                    <div class="ba-top"><span class="ba-title">{{ $t('ct-checkout-shipping') }}</span></div>
                    <div class=" ba-flex ba-gp-1 ba-jc-sb ba-f-wrap">

                      <div class="ba-box-input w-full">
                        <div class="ba-info">
                          <div class="ba-info-left">
                              <label class="ba-label" style="font-family: Montserrat; font-weight: 500; font-size: 14px;">
                                {{ $t('ct-checkout-input') }}
                                <span style="color: red;">*</span>
                              </label>
                            </div>
                        </div> 
                        <input :placeholder="$t('ct-checkout-empty-input')" type="text" class="ba-input ba-w-100" readonly="readyonly" :value="$t('ct-checkout-filled-input')">
                      </div>

                      <div class="ba-box-input w-1/2">
                        <div class="ba-info">
                          <div class="ba-info-left">
                              <label class="ba-label" style="font-family: Montserrat; font-weight: 500; font-size: 14px;">
                                {{ $t('ct-checkout-input') }}
                                <span style="color: red;">*</span>
                              </label>
                            </div>
                        </div> 
                        <select name="state" class="ba-input ba-w-100 " readonly="readonly">
                          <option selected="selected">{{$t('ct-checkout-filled-input')}}</option>
                        </select>
                      </div>

                      <div class="ba-box-input w-1/2 pl-1">
                        <div class="ba-info">
                          <div class="ba-info-left">
                              <label class="ba-label" style="font-family: Montserrat; font-weight: 500; font-size: 14px;">
                                {{ $t('ct-checkout-input') }}
                              </label>
                            </div>
                        </div> 
                        <input :placeholder="$t('ct-checkout-empty-input')" type="text" class="ba-input ba-w-100" readonly="readyonly">
                      </div>

                      <div class="ba-box-input w-1/3">
                        <div class="ba-info">
                          <div class="ba-info-left">
                              <label class="ba-label" style="font-family: Montserrat; font-weight: 500; font-size: 14px;">
                                {{ $t('ct-checkout-input') }}
                              </label>
                            </div>
                        </div> 
                        <input :placeholder="$t('ct-checkout-empty-input')" type="text" class="ba-input ba-w-100" readonly="readyonly">
                      </div>

                      <div class="ba-box-input w-2/3">
                        <div class="ba-info">
                          <div class="ba-info-left">
                              <label class="ba-label" style="font-family: Montserrat; font-weight: 500; font-size: 14px;">
                                {{ $t('ct-checkout-input') }}
                              </label>
                            </div>
                        </div> 
                        <input :placeholder="$t('ct-checkout-empty-input')" type="text" class="ba-input ba-w-100" readonly="readyonly">
                      </div>

                    </div>
                    <div class="ba-w-100">
                      <div class="ba-top"><span class="ba-title">{{ $t('ct-checkout-secure-payment') }}</span>
                      </div>
                      <div>
                        <div class="ba-w-100"
                          style="display: flex; gap: 1rem; flex-wrap: wrap; justify-content: center;"><label
                            class="ba-input ba-md"
                            style="display: flex; align-items: center; gap: 0.5rem; flex-direction: row; background-color: rgba(255, 255, 255, 0);">
                            <input type="radio" name="payment" readonly="readonly" checked="checked"> <svg xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 60 60" class="fill-current" style="width: 24px; height: 24px;">
                              <path
                                d="M55.783 8H4.217A4.222 4.222 0 0 0 0 12.217v35.566A4.222 4.222 0 0 0 4.217 52h51.566A4.222 4.222 0 0 0 60 47.783V12.217A4.222 4.222 0 0 0 55.783 8zM58 47.783A2.22 2.22 0 0 1 55.783 50H4.217A2.22 2.22 0 0 1 2 47.783V12.217A2.22 2.22 0 0 1 4.217 10h51.566A2.22 2.22 0 0 1 58 12.217v35.566z">
                              </path>
                              <path
                                d="M16 37H7a1 1 0 1 0 0 2h9a1 1 0 1 0 0-2zM29 37h-9a1 1 0 1 0 0 2h9a1 1 0 1 0 0-2zM8 42H7a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zM14 42h-2a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2zM19 42h-1a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zM25 42h-2a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2zM28.29 42.29c-.181.19-.29.45-.29.71 0 .26.109.52.29.71.189.18.45.29.71.29s.52-.11.71-.29c.18-.19.29-.45.29-.71 0-.26-.11-.52-.29-.71-.38-.37-1.061-.37-1.42 0zM48 33a6.953 6.953 0 0 0-3.5.947A6.953 6.953 0 0 0 41 33c-3.859 0-7 3.14-7 7s3.141 7 7 7a6.953 6.953 0 0 0 3.5-.947A6.953 6.953 0 0 0 48 47c3.859 0 7-3.14 7-7s-3.141-7-7-7zm-2 7a4.98 4.98 0 0 1-1.5 3.562 4.98 4.98 0 0 1 0-7.124A4.98 4.98 0 0 1 46 40zm-10 0c0-2.757 2.243-5 5-5 .631 0 1.23.13 1.787.345C41.68 36.583 41 38.212 41 40s.68 3.417 1.787 4.655A4.946 4.946 0 0 1 41 45c-2.757 0-5-2.243-5-5zm12 5c-.631 0-1.23-.13-1.787-.345C47.32 43.417 48 41.788 48 40s-.68-3.417-1.787-4.655A4.946 4.946 0 0 1 48 35c2.757 0 5 2.243 5 5s-2.243 5-5 5zM8.255 30h13.49A2.258 2.258 0 0 0 24 27.745v-9.49A2.258 2.258 0 0 0 21.745 16H8.255A2.258 2.258 0 0 0 6 18.255v9.49A2.258 2.258 0 0 0 8.255 30zM12 24H8v-2h4v2zm-4 3.745V26h4v1.745c0 .087.016.17.026.255H8.255A.255.255 0 0 1 8 27.745zM22 24h-4v-1.745c0-.141.114-.255.255-.255h3.49c.087 0 .17-.016.255-.026V24zm-.255 4h-3.771c.01-.085.026-.168.026-.255V26h4v1.745a.255.255 0 0 1-.255.255zm0-10c.141 0 .255.114.255.255v1.49a.255.255 0 0 1-.255.255h-3.49A2.258 2.258 0 0 0 16 22.255v5.49a.255.255 0 0 1-.255.255h-1.49a.255.255 0 0 1-.255-.255v-9.49c0-.141.114-.255.255-.255h7.49zm-13.49 0h3.771c-.01.085-.026.168-.026.255V20H8v-1.745c0-.141.114-.255.255-.255z">
                              </path>
                            </svg> <span style="font-family: Montserrat; font-weight: 500; font-size: 14px;">{{ $t('ct-checkout-payment-method') }} 1</span></label><label
                            class="ba-input ba-md"
                            style="display: flex; align-items: center; gap: 0.5rem; flex-direction: row; background-color: rgba(255, 255, 255, 0);"><input
                              type="radio" name="payment" readonly="readonly"> <svg xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 60 60" class="fill-current" style="width: 24px; height: 24px;">
                              <path
                                d="M55.783 8H4.217A4.222 4.222 0 0 0 0 12.217v35.566A4.222 4.222 0 0 0 4.217 52h51.566A4.222 4.222 0 0 0 60 47.783V12.217A4.222 4.222 0 0 0 55.783 8zM58 47.783A2.22 2.22 0 0 1 55.783 50H4.217A2.22 2.22 0 0 1 2 47.783V12.217A2.22 2.22 0 0 1 4.217 10h51.566A2.22 2.22 0 0 1 58 12.217v35.566z">
                              </path>
                              <path
                                d="M16 37H7a1 1 0 1 0 0 2h9a1 1 0 1 0 0-2zM29 37h-9a1 1 0 1 0 0 2h9a1 1 0 1 0 0-2zM8 42H7a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zM14 42h-2a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2zM19 42h-1a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zM25 42h-2a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2zM28.29 42.29c-.181.19-.29.45-.29.71 0 .26.109.52.29.71.189.18.45.29.71.29s.52-.11.71-.29c.18-.19.29-.45.29-.71 0-.26-.11-.52-.29-.71-.38-.37-1.061-.37-1.42 0zM48 33a6.953 6.953 0 0 0-3.5.947A6.953 6.953 0 0 0 41 33c-3.859 0-7 3.14-7 7s3.141 7 7 7a6.953 6.953 0 0 0 3.5-.947A6.953 6.953 0 0 0 48 47c3.859 0 7-3.14 7-7s-3.141-7-7-7zm-2 7a4.98 4.98 0 0 1-1.5 3.562 4.98 4.98 0 0 1 0-7.124A4.98 4.98 0 0 1 46 40zm-10 0c0-2.757 2.243-5 5-5 .631 0 1.23.13 1.787.345C41.68 36.583 41 38.212 41 40s.68 3.417 1.787 4.655A4.946 4.946 0 0 1 41 45c-2.757 0-5-2.243-5-5zm12 5c-.631 0-1.23-.13-1.787-.345C47.32 43.417 48 41.788 48 40s-.68-3.417-1.787-4.655A4.946 4.946 0 0 1 48 35c2.757 0 5 2.243 5 5s-2.243 5-5 5zM8.255 30h13.49A2.258 2.258 0 0 0 24 27.745v-9.49A2.258 2.258 0 0 0 21.745 16H8.255A2.258 2.258 0 0 0 6 18.255v9.49A2.258 2.258 0 0 0 8.255 30zM12 24H8v-2h4v2zm-4 3.745V26h4v1.745c0 .087.016.17.026.255H8.255A.255.255 0 0 1 8 27.745zM22 24h-4v-1.745c0-.141.114-.255.255-.255h3.49c.087 0 .17-.016.255-.026V24zm-.255 4h-3.771c.01-.085.026-.168.026-.255V26h4v1.745a.255.255 0 0 1-.255.255zm0-10c.141 0 .255.114.255.255v1.49a.255.255 0 0 1-.255.255h-3.49A2.258 2.258 0 0 0 16 22.255v5.49a.255.255 0 0 1-.255.255h-1.49a.255.255 0 0 1-.255-.255v-9.49c0-.141.114-.255.255-.255h7.49zm-13.49 0h3.771c-.01.085-.026.168-.026.255V20H8v-1.745c0-.141.114-.255.255-.255z">
                              </path>
                            </svg> <span style="font-family: Montserrat; font-weight: 500; font-size: 14px;">{{ $t('ct-checkout-payment-method') }} 2</span></label></div>
                        <div class="payment-box ba-w-100">
                          <div></div>
                        </div>
                        <div>
                          <footer>
                            <div class="container">
                              <div class="payment-button-area">
                                <div class="gateway-payment-button">
                                  <div>
                                    <button type="button" class="big-nice-button">
                                      <span>{{ trans(config.texts.payment_button) }}</span>
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div><span style="font-size: 12px;">{{
                                config.texts.security_text || '*' + $t('ct-checkout-secure-payments') + '*' }}</span>
                              </div>
                            </div>
                          </footer>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="invoice-product-info">
              <div class="ba-card ba-w-100" style="height: 100%;">
                <div class="ba-top"><span class="ba-title">{{ $t('ct-checkout-pricing') }}</span></div>
                <div class="ba-content ba-w-100">
                  <div>
                    <div v-if="sellable" class="ba-flex ba-shadow-0 ba-card"
                      style="flex-direction: row; padding: 16px; margin-bottom: 16px; box-shadow: none; border: 1px solid rgb(228, 234, 246);">
                      <div style="flex: 1; max-width: 137px;"><img :src="sellable.image.fullUrl" :alt="sellable.name"
                          class="ba-image" style="width: 137px;"></div>
                      <div style="flex: 1; max-width: 212px;"><span class="ba-title ba-w-100"
                          style="font-size: 16px;">{{sellable.name}}</span>
                          <div class="ba-description ba-w-100" :class="{ 'trim-description': sellable.description.length > 400 }" 
                            v-html="sellable.description" :title="sellable.description_text">
                          </div>
                      </div>
                    </div>


                    <div v-else class="ba-flex ba-shadow-0 ba-card"
                      style="flex-direction: row; padding: 16px; margin-bottom: 16px; box-shadow: none; border: 1px solid rgb(228, 234, 246);">
                      <div style="flex: 1; max-width: 137px;">
                        <div class="ba-image" style="width: 137px; height:137px; background-color: #EFF2F8; border-radius: 20px"></div>
                        </div>
                      <div style="flex: 1; max-width: 212px;"><span class="ba-title ba-w-100"
                          style="font-size: 16px;">{{$t('ct-checkout-product-info')}}</span>
                          <div class="ba-description ba-w-100" :class="{ 'trim-description': $t('ct-checkout-product-info') > 400 }" 
                            v-html="$t('ct-checkout-product-info')" :title="$t('ct-checkout-product-info')">
                          </div>
                      </div>
                    </div>

                    <div class="ba-top ba-flex" style="gap: 0px; margin-bottom: 16px;">
                      <div style="flex: 1; margin: 0px; padding: 0px;"><span class="ba-title"
                          style="font-size: 16px;">{{ $t('ct-checkout-product') }}</span></div>
                      <div class="ba-title ba-text-right" style="font-size: 16px;">{{ trans(':price') }}</div>
                    </div>
                    <div class="ba-w-100">
                      <div class="ba-w-100 ba-pd-b-1">
                        <div class="ba-top">
                          <div class="ba-title ba-flex ba-w-100" style="margin-bottom: 16px;"><span
                              style="font-size: 16px;">{{ $t('ct-checkout-shipping') }}</span></div>
                        </div>
                        <div class="form-shipping coupon-box">
                          <label class="shipping-item" style="grid-template-columns: 10% auto 30% 25%;">
                            <input name="shipping" type="radio" checked="checked" readonly="readonly"> 
                            <span style="font-family: Montserrat; font-weight: 500; font-size: 14px;"> {{ $t('ct-checkout-shipping') }} 1 </span>
                            <span style="font-family: Montserrat; font-weight: 500; font-size: 14px;"> 13 - 14 {{ $t('ct-checkout-days') }} </span> 
                            <span style="font-family: Montserrat; font-weight: 500; font-size: 14px;">{{ trans(':shipping') }} </span>
                          </label>
                          <label class="shipping-item" style="grid-template-columns: 10% auto 30% 25%;">
                            <input name="shipping" type="radio" readonly="readonly"> 
                            <span style="font-family: Montserrat; font-weight: 500; font-size: 14px;"> {{ $t('ct-checkout-shipping') }} 2 </span> 
                            <span style="font-family: Montserrat; font-weight: 500; font-size: 14px;"> 7 - 8 {{ $t('ct-checkout-days') }} </span> 
                            <span style="font-family: Montserrat; font-weight: 500; font-size: 14px;">{{ trans(':shipp2') }} </span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="ba-w-100">
                      <div class="ba-top">
                        <div class="ba-title ba-flex ba-w-100" style="margin-bottom: 16px;"><span class="ba-w-50"
                            style="font-size: 16px; margin: 0px; padding: 0px;">{{ $t('ct-checkout-quantity') }}</span>
                        </div>
                      </div>
                      <div class="quantity-box-options">
                        <div class="quantity-option"><label>
                          <input type="radio" readonly="readonly" checked="checked">
                            <div class="quantity-option-label">
                              cx
                            </div>
                            <div class="quantity-option-value"><span style="font-family: Montserrat; font-weight: 500; font-size: 14px;">
                                10% OFF
                              </span> <span style="font-family: Montserrat; font-weight: 500; font-size: 14px;">( {{ $t('ct-checkout-quantity') }}:
                                12 )</span></div>
                          </label></div>
                      </div>
                    </div>
                    <div class="ba-w-100">
                      <div class="ba-top ba-flex" style="gap: 0px; margin-bottom: 16px;">
                        <div style="flex: 1; margin: 0px; padding: 0px;"><span class="ba-title"
                            style="color: #000; font-size: 16px;">
                            {{ $t('ct-checkout-subtotal') }}</span></div>
                        <div class="ba-title" style="font-size: 16px;">{{ trans(':subtotal') }}</div>
                      </div>
                      <div class="ba-w-100">
                        <div class="ba-top ba-w-100 ba-flex" style="gap: 0px; margin-bottom: 16px;">
                          <div style="flex: 1; margin: 0px; padding: 0px;"><span class="ba-title"
                              style="font-size: 16px;">{{ $t('ct-checkout-quantity-discount')
                              }}</span></div>
                          <div class="ba-title ba-text-right" style="font-size: 16px;">-{{ trans(':discount') }}</div>
                        </div>
                        <div class="ba-top ba-w-100 ba-flex" style="gap: 0px; margin-bottom: 16px;">
                          <div style="flex: 1; margin: 0px; padding: 0px;"><span class="ba-title"
                              style="font-size: 16px;">{{ $t('ct-checkout-shipping') }}</span>
                          </div>
                          <div class="ba-title ba-text-right" style="font-size: 16px;">{{ trans(':shipping') }}
                          </div>
                        </div>
                        <div class="ba-top ba-w-100 ba-flex" style="gap: 0px; margin-bottom: 16px;">
                          <div style="flex: 1; margin: 0px; padding: 0px;"><span class="ba-title"
                              style="font-size: 16px;">VAT {{ $t('ct-checkout-for-country') }}({{ $t('ct-checkout-inclusive') }})</span></div>
                          <div class="ba-title ba-text-right" style="font-size: 16px;">{{ trans(':vat') }}
                          </div>
                        </div>
                      </div>
                      <div class="ba-top ba-flex" style="gap: 0px; margin-bottom: 16px;">
                        <div style="flex: 1; margin: 0px; padding: 0px;"><span class="ba-title"
                            style="color: #000; font-size: 16px;">{{ $t('ct-checkout-totals') }}</span></div>
                        <div class="ba-title ba-text-right" style="border: 0px;"><span class="ba-title"
                            style="font-size: 16px;">{{ trans(':total') }}</span></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['config', 'sellable', 'e'],
  data: vm => ({
    currentStep: 1
  }),
  computed: {
    selectedTheme() {
      return this.config ? this.config.theme : null;
    }
  },
  methods: {
    trans(text) {
      if (!text) return text;

      const priceCents = (this.sellable && this.sellable.price) ? this.sellable.price : 5000;
      const currency = (this.sellable && this.sellable.currency) ? this.sellable.currency : 'USD';
      const price = priceCents / 100;

      const subtotal = price * 12;
      const discount = subtotal * 0.10;
      const vat = 1.7;
      const shipping = 10.94;
      const shipp2 = 29.15;
      const total = subtotal + shipping + vat - discount;

      function formatCurrency(value) {
        const formatted = value.toFixed(2);
        if (currency === 'BRL') {
          return 'R$' + formatted.replace('.', ',');
        } else if (currency === 'EUR') {
          return formatted + ' €';
        } else {
          return '$' + formatted;
        }
      }

      const replacements = {
        gateway: this.$t('ct-checkout-payment-method'),
        price: formatCurrency(price),
        subtotal: formatCurrency(subtotal),
        discount: formatCurrency(discount),
        vat: formatCurrency(vat),
        shipping: formatCurrency(shipping),
        shipp2: formatCurrency(shipp2),
        total: formatCurrency(total)
      };

      let result = text;
      for (const key in replacements) {
        result = result.replace(`:${key}`, replacements[key]);
      }

      return result;
    }
  }
};
</script>

<style src="./onestep.css" scoped />



// WEBPACK FOOTER //
// src/components/editor/apps/Checkout/Form/ThemePreviewOneStep.vue